import * as Dom from './Dom'
import { debounce } from '@Shared/Functions'

/**
 * Encontra o elemento de formulário que contém o input.
 *
 * @param {HTMLElement} input
 */
export function form(input) {
    return Dom.findParent(input, p => p.tagName == 'FORM')
}

export function allInputs(form) {
    return Array.from(form.querySelectorAll('input,select,trix-editor,textarea'))
}

/**
 * Notifica por callback todas as vezes que o input de `name` for alterado.
 *
 * @param {HTMLFormElement} form
 * @param {string} name
 */
export function vigiar(form, name, callback) {
    callback = debounce(callback, 100)

    let input = form.querySelector('[name="' + name + '"]')

    if (!input) return false

    let trigger = () => {
        if (name.indexOf('[]') !== -1) {
            let inputs = Array.from(form.querySelectorAll(`[name="${name}"]`)).map(i => i.value)
            callback(inputs)
        } else {
            callback(input.value)
        }
    }

    input.addEventListener('change', ev => {
        trigger()
    })

    trigger()

    return true
}

export function appendObjectToFormData(formData, data) {
    let appendValue = (value, key, prefix) => {
        console.log({ key, value, prefix })
        if (Array.isArray(value)) {
            value.forEach((item, index) => {
                appendValue(item, prefix + key + '[' + index + ']', '')
            })
        } else if (typeof value == 'object' && value) {
            Object.keys(value).forEach(valueKey => {
                appendValue(value[valueKey], '', prefix + key + '[' + valueKey + ']')
            })
        } else {
            formData.append(prefix + key, value)
        }
    }

    Object.keys(data).forEach(key => {
        let value = data[key]
        appendValue(value, key, '')
    })
}

/**
 * Essa função recebe uma lista de campos (flat) e identifica a dependência entre os campos, montando uma árvore
 * encadeada.
 *
 * @param {*} fields
 */
export function buildDependencyTree(fields) {
    return fields.filter(field => {
        let cond = field.atributos_extras.conditionals
        if (cond && cond != 'null' && cond.length > 0) {
            return false
        }

        return true
    })
}

export function typeName(field) {
    let map = {
        text: 'Texto de uma linha',
        textarea: 'Texto de várias linhas',
        email: 'E-mail',
        html: 'HTML livre',
        single_file: 'Upload de arquivo',
        multiple_files: 'Upload de vários arquivos',
        puzzle_pieces: 'Peças de quebra-cabeça',
        select: 'Selecionar opção',
        select_checkbox: 'Selecionar várias opções',
        select_radio: 'Selecionar opção',
        phone_number: 'Número de telefone',
    }

    let type = field.type || 'text'
    if (field.reference) type = field.reference.atributos_extras.tipo || 'text'

    return map[type] || type
}

/**
 * Tipo do campo. Pode ser 'text', 'textarea', 'select', etc.
 *
 * @param {*} field
 * @returns string
 */
export function type(field) {
    if (name(field) === 'whatsapp_jid') return 'whatsapp_jid'

    if (field.reference) return field.reference.atributos_extras.tipo || 'text'
    if (field.atributos_extras && field.atributos_extras.tipo) return field.atributos_extras.tipo || 'text'
    return field.type || 'text'
}

export function name(field) {
    if (field.reference) return field.reference.nome || field.reference.label
    return field.name || field.nome || field.atributo || field.label
}

export function placeholder(field) {
    if (field.placeholder) return field.placeholder
    if (field.reference) return field.reference.placeholder
    return field.placeholder
}

export function required(field) {
    if (field.required == 'on' || field.required === true) return true
    if (field.reference) return field.reference.obrigatório
    if ('obrigatório' in field) return field.obrigatório
    return false
}

/**
 * Does the field have a unique constraint?
 *
 * @param {*} field
 * @returns {boolean}
 */
export function isUnique(field) {
    if (field.reference) return field.reference.is_unique
}

export function conditionalMatch(record, condition) {
    for (let attributeName in condition) {
        let criteria = condition[attributeName]
        let currentValue = record[attributeName]

        if (criteria.operator == 'equals') {
            if (!currentValue) return false
            if (criteria.value.indexOf(currentValue.toString()) === -1) {
                return false
            }
        }
    }

    return true
}
